// Shared look for the instructor roster (design: "Instructor Roster FF050").
export const DS = {
  live: "#c23d68",
  liveBg: "color-mix(in srgb, var(--color-accent-pink) 15%, transparent)",
  danger: "var(--color-danger)",
  danger50: "var(--color-danger-bg)",
  success: "var(--color-success)",
  blue: "#1d4ed8",
  blueDark: "#1e40af",
  blueBg: "rgba(59,130,246,0.09)",
  grey: "rgba(31,22,51,0.5)",
  greyBg: "var(--color-surface-press-light)",
  ink: "var(--color-ink)",
  ink2: "rgba(31,22,51,0.75)",
  ink3: "rgba(31,22,51,0.6)",
  ink4: "rgba(31,22,51,0.5)",
  line: "var(--color-hairline-cloud)",
  line2: "var(--color-hairline-cloud)",
  line3: "var(--color-hairline-cloud)",
  surface2: "var(--color-surface-press-light)",
};

export const AVATAR_GRADIENTS = [
  "linear-gradient(135deg, #B5651D, #C2410C)",
  "linear-gradient(135deg, var(--color-primary), var(--color-primary))",
  "linear-gradient(135deg, #15803D, var(--color-accent-violet))",
  "linear-gradient(135deg, var(--color-accent-violet), var(--color-primary))",
  "linear-gradient(135deg, #B42318, #C2410C)",
  "linear-gradient(135deg, var(--color-ink-2), var(--color-ink))",
];

export const PULSE_KEYFRAME = `
  @keyframes roster-pulse {
    0%   { transform: scale(.6); opacity: .45; }
    100% { transform: scale(1.9); opacity: 0; }
  }
`;

export function getInitials(name = "") {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}
